/**
 * Сервис для работы с API авторизации
 */
import api from './api';
import type { LoginRequest, LoginResponse, User } from '@/types/auth';

const TOKEN_KEY = 'auth_token';

class AuthService {
  /**
   * Вход в систему
   */
  async login(username: string, password: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', {
      username,
      password,
    } as LoginRequest);

    // Сохраняем токен в localStorage
    this.setToken(response.session_token);

    return response;
  }

  /**
   * Выход из системы
   */
  async logout(): Promise<void> {
    try {
      // Токен автоматически добавится через interceptor
      await api.post('/auth/logout', {});
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }

    // Удаляем токен из localStorage
    this.removeToken();
  }

  /**
   * Получить информацию о текущем пользователе
   */
  async getCurrentUser(): Promise<User> {
    const token = this.getToken();

    if (!token) {
      throw new Error('Токен не найден');
    }

    // Токен автоматически добавится через interceptor
    const response = await api.get<User>('/auth/me');
    return response;
  }

  /**
   * Сохранить токен в localStorage
   */
  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  /**
   * Получить токен из localStorage
   */
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  /**
   * Удалить токен из localStorage
   */
  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  /**
   * Проверить, авторизован ли пользователь
   */
  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}

export default new AuthService();
